import ionicCoreGlobalScript from '/home/tobi/workspace/eduApplication/src/client/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import appGlobalScript from '/home/tobi/workspace/eduApplication/src/client/src/global/app.ts';
export const globalScripts = () => {
  return Promise.all([
    appGlobalScript(),
    ionicCoreGlobalScript(),
  ]);
};
